const getUnitsByFeatures = (features, units) => {
    if (!features || !Array.isArray(features)) {
        console.warn('Invalid features input:', features);
        return [];
    }
    
    if (!units || !Array.isArray(units)) {
        console.warn('Invalid units input:', units);
        return [];
    }
    
    // If no features are selected, return empty array
    if (features.length === 0) {
        return [];
    }
    
    // Get all unit IDs from the features
    const unitIdsFromFeatures = new Set();

    features.forEach(feature => {
        if (feature.properties && feature.properties.units) {
            feature.properties.units.forEach(unitId => {
                unitIdsFromFeatures.add(unitId);
            });
        }
    });
    
    // Filter units that have their companyId in the features' unit lists
    return units.filter(unit => unit.companyId && unitIdsFromFeatures.has(unit.companyId));
};

export {
    getUnitsByFeatures
};